import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CaretNextIcon = (props) => (
  <SvgIcon viewBox="0 0 9 15" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.61688 6.88117L2.49333 0.757624C2.15162 0.415916 1.5976 0.415916 1.25589 0.757624C0.914186 1.09933 0.914186 1.65335 1.25589 1.99506L6.76072 7.49989L1.25589 13.0047C0.914186 13.3464 0.914186 13.9004 1.25589 14.2422C1.5976 14.5839 2.15162 14.5839 2.49333 14.2422L8.61688 8.11861C8.95859 7.7769 8.95859 7.22288 8.61688 6.88117Z"
    />
  </SvgIcon>
);

export default CaretNextIcon;

